export { default as NikoCorporateListTemplate } from './NikoCorporateList';
